import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { GeneralQuality, GeneralType, GovernyInfo } from "../../../../lib/types";
import { getData } from "../../../../lib/commonFunctions";
import SubMenu from "../../../Menu/SubMenu";
import { DragescentState } from "../../../../store/reducers/stateType";
import { portraits } from "../../../../assets/images/races";
import GovernorateInfoLink from "../../../Common/GovernorateInfoLink";

type OverviewRowData = {
  soldier: GeneralType;
  mage: GeneralType;
  thief: GeneralType;
  economist: GeneralType;
}

interface ISkillLineProps {
  skill: GeneralQuality
}

const SkillLine = ({ skill }: ISkillLineProps) => <div style={{ whiteSpace: "nowrap" }}>{skill.name}: <span className={"white"}>{skill.level}</span></div>;

const GeneralsOverview = () => {
  const [data, setData] = useState<{[keys: string]: OverviewRowData} | null>(null);
  const emperor = useSelector((state: DragescentState) => state.governorate.alliance.emperor);
  const members = useSelector((state: DragescentState) => state.governorate.alliance.members);

  useEffect(() => {
    getData(`/api/overview/generals`)
      .then(overviewData => setData(overviewData));
  }, []);

  return (
    <>
      <SubMenu
        tabs={[
          {
            name: "AllianceOverview",
            title: "Overview",
            icon: "imperator",
            label: "Alliance",
            active: false,
            parameters: {
              reload: true
            }
          },
          {
            name: "GeneralsOverview",
            title: "Overview",
            icon: "imperator",
            label: "Generals",
            active: true,
            parameters: {
              reload: false
            }
          },
          {
            name: "DevelopmentOverview",
            title: "Overview",
            icon: "imperator",
            label: "Development",
            active: false,
            parameters: {
              reload: true
            }
          },
          {
            name: "OverviewPalace",
            title: "Overview",
            icon: "imperator",
            label: "Overview Palace",
            active: false,
            parameters: {
              reload: true
            }
          }
        ]}
      />

      <div className="box imp-overview" style={{ overflowX: "scroll" }}>
        {data && <table className={"table table-tbody-hover"}>
          <thead>
          <tr>
            <th style={{ textAlign: "left" }}>Governorate</th>
            <th>Mage</th>
            <th>Thief</th>
            <th>Economist</th>
            <th>Soldier</th>
          </tr>
          </thead>
          {members.map((member: GovernyInfo) => {
            const mage = data[member.id].mage && data[member.id].mage.general;
            const thief = data[member.id].thief && data[member.id].thief.general;
            const economist = data[member.id].economist && data[member.id].economist.general;
            const soldier = data[member.id].soldier && data[member.id].soldier.general;
            return (
              <tbody>
              <tr>
                <td rowSpan={2} className="no-padding-left text-left">
                <span>
                  <img width={37} height={37} src={portraits[member.race.name]} alt={"Race portrait"}/>
                </span>
                  <span style={{ display: "inline-table", verticalAlign: "super" }}>
                    <GovernorateInfoLink
                      govId={member.id}
                      name={member.name}
                      raceName={member.race.name}
                    /><br/>
                    {member.commander && <i className={`icon icon-vojevudce icon-xs ${member.race.name}`}/>}
                    {emperor.id === member.id && <i className={`icon icon-imperator icon-xs ${member.race.name}`}/>}
                </span>
                </td>
                <td style={{ verticalAlign: "top" }}>
                  {(mage && ((mage.skills.some(skill => skill.level)
                    && <>{mage.skills.filter(skill => skill.level)
                      .map(skill => <SkillLine skill={skill}/>)}</>) || <div className={"dark-grey"}>No skill learnt</div>))
                  || <div className={"dark-grey"}>Not in crew</div>}
                </td>
                <td style={{ verticalAlign: "top" }}>
                  {(thief && ((thief.skills.some(skill => skill.level)
                    && thief.skills.filter(skill => skill.level)
                      .map(skill => <SkillLine skill={skill} />)) || <div className={"dark-grey"}>No skill learnt</div>))
                  || <div className={"dark-grey"}>Not in crew</div>}
                </td>
                <td style={{ verticalAlign: "top" }}>
                  {(economist && ((economist.skills.some(skill => skill.level)
                    && economist.skills.filter(skill => skill.level)
                      .map(skill => <SkillLine skill={skill} />)) || <div className={"dark-grey"}>No skill learnt</div>))
                  || <div className={"dark-grey"}>Not in crew</div>}
                </td>
                <td style={{ verticalAlign: "top" }}>
                  {(soldier && ((soldier.skills.some(skill => skill.level)
                    && soldier.skills.filter(skill => skill.level)
                      .map(skill => <SkillLine skill={skill} />)) || <div className={"dark-grey"}>No skill learnt</div>))
                  || <div className={"dark-grey"}>Not in crew</div>}
                </td>
              </tr>
              <tr>
                <td>
                  {mage ? <>Free points: {mage.skillPoints}</> : ""}
                </td>
                <td>
                  {thief ? <>Free points: {thief.skillPoints}</> : ""}
                </td>
                <td>
                  {economist ? <>Free points: {economist.skillPoints}</> : ""}
                </td>
                <td>
                  {soldier ? <>Free points: {soldier.skillPoints}</> : ""}
                </td>
              </tr>
              </tbody>)
          })
          }
        </table>}
      </div>
    </>
  )
}

export default GeneralsOverview;
